module.exports = __webpack_public_path__ + "media/images/no_content.icon.vacancies-9c1fe225.svg";